import React from 'react';

import GatewayHeader from './GatewayHeader';
import GatewayFooter from './GatewayFooter';
import './gateway.css';

// While true, the draft notice shows and <Tbc> placeholders are highlighted.
// Set to false once legal review is complete and every <Tbc> has been replaced.
export const LEGAL_DRAFT = false;

const bodyStyle = { fontFamily: 'var(--gw-font-sans)', fontSize: 16, lineHeight: 1.7, color: '#374151' };

export const Tbc = ({ children }) => (
  <span style={LEGAL_DRAFT ? { background: '#fff3cd', padding: '0 4px', borderRadius: 4 } : undefined}>{children}</span>
);

export const Section = ({ id, number, title, children }) => (
  <section id={id} aria-labelledby={`${id}-heading`} style={{ marginTop: 44 }}>
    <h2 id={`${id}-heading`} style={{ margin: '0 0 14px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em', color: '#1c2b4a' }}>
      {number}. {title}
    </h2>
    <div style={bodyStyle}>{children}</div>
  </section>
);

export const List = ({ items }) => (
  <ul style={{ margin: '8px 0 16px', paddingLeft: 22 }}>
    {items.map((item, i) => <li key={i} style={{ marginBottom: 6 }}>{item}</li>)}
  </ul>
);

export const Callout = ({ label, children }) => (
  <div style={{ margin: '18px 0', padding: '16px 20px', borderRadius: 12, background: '#f4f8fe', borderLeft: '4px solid #1c2b4a' }}>
    <strong style={{ color: '#c0392b' }}>{label}</strong> {children}
  </div>
);

export const Table = ({ caption, headers, rows }) => (
  <div style={{ overflowX: 'auto', margin: '12px 0 18px' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 15 }}>
      <caption style={{ position: 'absolute', left: -9999 }}>{caption}</caption>
      <thead>
        <tr>
          {headers.map((h) => (
            <th key={h} scope="col" style={{ textAlign: 'left', padding: '10px 12px', background: '#1c2b4a', color: '#fff', fontWeight: 700 }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} style={{ background: i % 2 ? '#f4f8fe' : '#fff' }}>
            {row.map((cell, j) => (
              <td key={j} style={{ padding: '10px 12px', borderBottom: '1px solid rgba(32,138,239,0.14)', verticalAlign: 'top' }}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const LegalPage = ({ title, lastUpdated, draftNotice = LEGAL_DRAFT, children }) => (
  <div className="gw-page">
    <GatewayHeader />
    <main id="main" style={{ maxWidth: 820, margin: '0 auto', padding: '72px 32px 0' }}>
      {draftNotice && (
        <div role="note" style={{ margin: '0 0 28px', padding: '12px 16px', borderRadius: 10, background: '#fff3cd', color: '#7a5b00', fontSize: 14, fontFamily: 'var(--gw-font-sans)' }}>
          <strong>Draft for legal review.</strong> Not legal advice. Highlighted text needs confirming before publication.
        </div>
      )}
      <h1 style={{ margin: 0, fontSize: 'clamp(30px, 3.6vw, 44px)', lineHeight: 1.08, fontWeight: 800, letterSpacing: '-0.02em', color: '#1c2b4a' }}>
        {title}
      </h1>
      <p style={{ margin: '14px 0 0', fontSize: 14, color: '#6b7280', fontFamily: 'var(--gw-font-sans)' }}>Last updated: {lastUpdated}</p>
      {children}
    </main>
    <GatewayFooter />
  </div>
);

export default LegalPage;
